import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../hooks/useApi";
import { Textarea } from "../../../../Input/Textarea";
import DefaultModalLayout from "../../../../Modal/DefaultModalLayout";
import { DeleteModalLabel } from "../../../Users/UserDetail/CommentModal/CommentDeleteModal";

interface CancelPointModalProps {
  cancelEvent: () => void;
  closeEvent: () => void;
  pointId: string;
}

export default function CancelPointModal({
  cancelEvent,
  closeEvent,
  pointId,
}: CancelPointModalProps) {
  const [deleteBtnClick, setDeleteBtnClick] = useState(false);
  const [reason, setReason] = useState("");

  // 코멘트 삭제
  const { response } = useApi({
    method: "post",
    url: deleteBtnClick ? `point/${pointId}` : undefined,
    data: {
      reason,
    },
  });

  console.log(response);

  useEffect(() => {
    if (response?.status === 200) {
      if (closeEvent) {
        closeEvent();
      }
      toast.success("포인트 지급이 취소되었습니다.", {});
    }
  }, [closeEvent, response]);

  return (
    <DefaultModalLayout
      modalTitle="포인트 지급 취소"
      isDeleteModal={true}
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setDeleteBtnClick(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>취소 사유</DeleteModalLabel>

      <Textarea
        placeholder="취소 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />
    </DefaultModalLayout>
  );
}
